import { lazy } from 'react';

export const PageUpdate = lazy(() => import('../pages/update'));
export const PageCart = lazy(() => import('../pages/cart'));
export const PagePayment = lazy(() => import('../pages/payment'));
export const PageIdentify = lazy(() => import('../pages/identify'));
export const PageNotFound = lazy(() => import('../pages/notFound'));
export const PageSubscriber = lazy(() => import('../pages/subscriber'));
export const PageInvalidOffer = lazy(() => import('../pages/invalidOffer'));
export const PagePaymentError = lazy(() => import('../pages/payment/error'));
export const PagePaymentErrorRetry = lazy(() => import('../pages/payment/errorRetry'));
export const PagePaymentErrorBlock = lazy(() => import('../pages/payment/errorBlock'));
export const PagePaymentErrorLimit = lazy(() => import('../pages/payment/errorLimit'));
export const PagePaymentErrorQarantine = lazy(() => import('../pages/payment/errorQuarantine'));
export const PagePaymentSuccess = lazy(() => import('../pages/payment/success'));
export const PagePaymentHalfSuccess = lazy(() => import('../pages/payment/halfSuccess'));
